/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CancelAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function CancelAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/Rename/Content/CancelAction",
  isSubmitting
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let renameIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'rename',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../No'))}
 data="rename"
 disabled={renameIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Cancel"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}